export enum FormulaErrorsOptions {
  ERROR = '#ERROR!',
  REF = '#REF!',
  DIV0 = '#DIV/0!',
  NAME = '#NAME?',
  NA = '#N/A',
  NUM = '#NUM!',
  VALUE = '#VALUE!',
}

export enum CellTypes {
  ITEM_REFERENCE = 'ItemReference',
  USAGE_AGGREGATOR_REFERENCE = 'UsageAggregatorReference',
  USAGE_QTY_AGGREGATOR = 'UsageQtyAggregator',
  NUMBER = 'Number',
  FORMULA = 'Formula',
  COUNT = 'Count',
  PERCENTAGE = 'Percentage',
  TEXT = 'Text',
  DATE = 'Date',
}

export enum RequiredColumnsEnum {
  amount = 'amount',
  quantity = 'quantity',
  price = 'price',
  item = 'item',
}
